module.exports = __webpack_public_path__ + "media/images/app-store-112b5061c9a310976a6a8e183742e366.webp";